export var error_msg_len = 8000;
export var def_msg_len = 5000;

export function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function markInvalidFields(form_controls, nested_controls) {
  // Check for any invalid form controls, and display them for the user
  for(var i in form_controls) {
    if(nested_controls) {
      var form_control_group = form_controls[i]['controls'];
      for(var j in form_control_group) {
        var form_control = form_control_group[j];
        markField(j, form_control);
      }
    }
    else {
      var form_control = form_controls[i];
      markField(i, form_control);
    }
  }
}

function markField(name, form_control) {
  if(form_control['invalid']) {
    var element = document.getElementById(name);
    element.classList.add("ng-touched");
    element.classList.add("ng-invalid");
    element.classList.remove("ng-untouched");
  }
}

export function lazyLoad() {
  setTimeout(function() {
    [].forEach.call(document.querySelectorAll('img'), function(img) {
      if(img.id && img.alt) {
        if (img.complete) {
          loadFullImage(img);
        }
        else {
          img.addEventListener('load', loadFullImage(img));
        }
      }
      else {
        img.removeAttribute('data-src');
      }
    });
  }, 300);
}

function loadFullImage(img) {
  var id = img.id.replace('-thumbnail', '')
  img.setAttribute('src', '/imgs/' + id + '/' + img.alt);
  img.onload = function() {
    img.removeAttribute('data-src');
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/utils.ts